import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = (state, profileId) => {
  const members = state.matches.members;
  if (isEmpty(members)) {
    return undefined;
  }
  if (!profileId) {
    return undefined;
  }
  const profile = members[profileId];
  if (!profile) {
    return undefined;
  }
  return profile;
};

const getMemberProfileById = createSelector(getData, profile => profile);

export default getMemberProfileById;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getMemberProfileById.js